App.controller('ZochLifeInsuranceDetailsCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaLifeInsuranceService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'insuranceService', 'zochaWorkersService', '$rootScope', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaLifeInsuranceService, $timeout, $stateParams, Blob, FileSaver, insuranceService, zochaWorkersService, $rootScope) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Szczegóły deklaracji';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.lifeInsurance.list';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.package;
    if (!$scope.data) {
        $state.go('root.home.zoch.lifeInsurance.list');
    }

    console.log('data',$scope.data);

    if ($scope.data.revision.partner && Object.keys($scope.data.revision.partner).length) {
        $scope.partner_length = true;
    }

    if ($scope.data.revision.children && $scope.data.revision.children.length) {
        $scope.children_length = true;
    }
    if ($scope.data.assured && $scope.data.assured.length) {
        $scope.assured_length = true;

    }

    angular.forEach($scope.data.assured, function (child, i) {
        if (child.zipCode.length === 5) {
            $scope.data.assured[i].zipCode = child.zipCode.slice(0, 2) + '-' + child.zipCode.slice(2, 5);
        }
    });








    $scope.partnerAdditionalFields = [];
    if ($rootScope.CONFIGURATOR.lifeInsurance.isBirthPlaceOfPartnerEnabled) {
        $scope.partnerAdditionalFields.push('birthplace');
    }

    $scope.getDeclaration = function(ev, value) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        var uuid = value.uuid, barcode = value.barcode;

        zochaLifeInsuranceService.getDeclaration(uuid).then(function (data) {
            if (data.status === 200) {
                data = new Blob([data.data], { type: 'application/pdf' });
                FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    }

    $scope.getStatement = function(ev, uuid) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        zochaLifeInsuranceService.getStatement(uuid).then(function (data) {
            if (data.status === 200) {
                var data = new Blob([data.data], { type: 'application/pdf' });
                FileSaver.saveAs(data, 'oswiadczenie.pdf');
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    }

    $scope.reason = 'EMPLOYEE_RESIGNATION';

    $scope.withdraw = function(id) {
        var criteria = {
            id: id,
            data: {
                withdrawalReason: $scope.reason
            }
        }

        if ($scope.reason === 'DEATH') {
            criteria.data.dateOfDeath = $scope.dateOfDeath
        }

        zochaLifeInsuranceService.withdraw(criteria).then(function (data) {
            if (data.status === 200) {
                $state.go('root.home.zoch.lifeInsurance.list');
            }
        });
    }


    $scope.goToDetails = function (ev, value) {
        if (ev) {
            ev.preventDefault();
            ev.stopPropagation();
        }
        console.log('[goToDetails] insuranceValue', value);
        zochaWorkersService.getWorkerById(value.declaration.userId).then(function (data) {
            if (data.status === 200) {
                return data.data;
            }
            return null;
        }).then(function (worker) {
            console.log('[goToDetails] worker', worker);
            if (!worker) {
                console.error('[goToDetails] worker not found', worker);
                return;
            }
            console.log('[goToDetails] $state.go', 'root.home.zoch.workers.details', {worker: worker});
            $state.go('root.home.zoch.workers.details', {worker: worker});
        }, function (err) {
            console.error('[goToDetails] getWorkerCandidate err', err);
        })
    };

    $scope.related = function () {
        $state.go('root.home.zoch.lifeInsurance.related', angular.extend($stateParams, {
            insurance: $scope.data
        }));
    };

    $scope.redirectToDeclarationById = function(declaration) {

        var replacedBarcode = declaration.replacedByBarcode;
        var replacedDeclarationId = declaration.replacedByLifeInsuranceDeclarationId;
        if (!replacedBarcode || !replacedDeclarationId) {
            return;
        }

        var criteria = {
            pageNumber: 0,
            pageSize: 10,
            search: replacedBarcode
        };

        zochaLifeInsuranceService.dataList(criteria).then(function (data) {
            if (data.status === 200) {
                var response = data.data.data;
                if (response.length === 1) {
                    var _correctDeclaration = response[0];
                    _correctDeclaration.activeStatus = _correctDeclaration.status === 'ACTIVE';
                    $state.go('root.home.zoch.lifeInsurance.details', {package: _correctDeclaration});
                } else {
                    for (var i = 0; i < response.length; i++) {
                        var _currentDeclaration = response[i];
                        if (_currentDeclaration.declaration.id === replacedDeclarationId) {
                            _currentDeclaration = _currentDeclaration === 'ACTIVE';
                            $state.go('root.home.zoch.lifeInsurance.details', {package: _currentDeclaration});
                        }
                    }
                }
            }
        });

    };

}]);
